import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';

export interface ProfileActionsProps {
  onEditProfile?: () => void;
  onOpenSettings?: () => void;
  onOpenFriends?: () => void;
}

const ProfileActions: React.FC<ProfileActionsProps> = ({ onEditProfile, onOpenSettings, onOpenFriends }) => {
  return (
    <View style={styles.container}>
      <View style={styles.titleRow}>
        <Text style={styles.title}>Quick Actions</Text>
      </View>

      <TouchableOpacity style={styles.item} onPress={onEditProfile} accessibilityRole="button">
        <Text style={styles.itemText}>Edit Profile</Text>
      </TouchableOpacity>

      <View style={styles.divider} />

      <TouchableOpacity style={styles.item} onPress={onOpenFriends} accessibilityRole="button">
        <Text style={styles.itemText}>Friends</Text>
      </TouchableOpacity>

      {/* Settings moved to bottom tab bar, but keeping prop for backward compatibility if needed, or removing it from UI */}
      {/* <View style={styles.divider} />
      <TouchableOpacity style={styles.item} onPress={onOpenSettings} accessibilityRole="button">
        <Text style={styles.itemText}>Settings</Text>
      </TouchableOpacity> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { backgroundColor: '#fff', borderRadius: 12, paddingVertical: 8, paddingHorizontal: 12, marginBottom: 16 },
  titleRow: { paddingVertical: 8 },
  title: { fontSize: 16, fontWeight: '700', color: '#333' },
  item: { paddingVertical: 14 },
  itemText: { fontSize: 16, color: '#333' },
  divider: { height: 1, backgroundColor: '#f5f5f5' },
});

export default ProfileActions;
